export default __webpack_public_path__ + "static/media/error-input-icon.f2244e64.svg";